<template>
  <div class="coming-soon-card">
    <h1 class="coming-soon-title">Coming Soon</h1>
    <p class="coming-soon-subtitle">
      We're working on new site content — stay tuned.
    </p>
  </div>
</template>

<script>
import "@/assets/css/topicContent.sass";

export default {
  name: "ComingSoonInfographic"
};
</script>
